import React from 'react';
import { Button, Typography } from '@mui/material';
import { List as IList } from 'immutable';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { getBrandElectronicCurrencyList } from '../brand/brandSelectors';
import Flag from '../localeCurrencyPicker/Flag';

const LanguageCurrencySelect = ({
    locale,
    fullySupportedLocalesUniqueArr,
    localesForSelectedCountry,
    isCurrencyPickerStatus,
    handleClickOpen,
    supportedElectronicCurrencyList,
    footer,
    isDialogOpen
}) => {
    const [languageCode, countryCode] = locale.split('-');

    const languageText = new Intl.DisplayNames([languageCode], {
        type: 'language'
    }).of(languageCode);


    const buttonDisabled = fullySupportedLocalesUniqueArr.length <= 1 && localesForSelectedCountry.size <= 1 && supportedElectronicCurrencyList.size <= 1;

    return (
        <>
            {fullySupportedLocalesUniqueArr.length <= 1 && localesForSelectedCountry.size <= 1 && supportedElectronicCurrencyList.size <= 1
                ? null
                : (isCurrencyPickerStatus && (
                    <div className='localizationHeaderNew header-text'>
                        <Button
                            disabled={buttonDisabled}
                            variant='text'
                            className='localizationHeaderButton'
                            onClick={handleClickOpen}
                            aria-haspopup="dialog"
                            aria-expanded={!!isDialogOpen}
                        >
                            {!footer && (<Flag countryCode={countryCode} />)}
                            <Typography component='span' className='localization-header-text'>
                                <span>
                                    {`${countryCode.toUpperCase()} - ${languageText}`}
                                </span>
                                <ExpandMoreIcon />
                            </Typography>
                            <span className="visually-hidden-span"> - Change language</span>
                        </Button>
                    </div>
                ))
            }
        </>
    );
};

LanguageCurrencySelect.defaultProps = {
    footer: false,
    isDialogOpen: false
};

LanguageCurrencySelect.propTypes = {
    locale: PropTypes.string.isRequired,
    fullySupportedLocalesUniqueArr: PropTypes.instanceOf(IList).isRequired,
    localesForSelectedCountry: PropTypes.object.isRequired,
    isCurrencyPickerStatus: PropTypes.bool.isRequired,
    handleClickOpen: PropTypes.func.isRequired,
    supportedElectronicCurrencyList: PropTypes.instanceOf(IList).isRequired,
    footer: PropTypes.bool,
    isDialogOpen: PropTypes.bool
};

export const mapStateToProps = state => ({
    supportedElectronicCurrencyList: getBrandElectronicCurrencyList(state)
});

export default connect(mapStateToProps)(LanguageCurrencySelect);
